import { AppCodesTable } from "./components/codes-table.component";
import { codesPageData } from "constants/codes-page.data";
import VuiTypography from "components/VuiTypography";
import { DashboardLayout } from "layouts/dashboard.layout";
import { AppCodesChallengeCounter } from "./components/codes-challenge-counter.component";
import { Grid } from "@mui/material";
import { AppCodesFilterState } from "./components/codes-filter-state.component";
import { Paginated } from "modules/dashboard/components/paginated.component";
import { useEffect, useState } from "react";
import {
  getPromoCodes,
  getCounterChallengesCodes,
} from "services/promo-codes/promo-codes.services";
import { unstable_batchedUpdates } from "react-dom";
import { updateInfoPromCode } from "services/promo-codes/promo-codes.services";

export function AppCodesPage() {
  const { labelPage, codesTableColumns, codesButtonStates, filterStateSelect } = codesPageData;

  const [urlSearchParams, setUrlSearchParams] = useState("");
  const [codeRows, setCodeRows] = useState([]);
  const [itemsCounter, setItemsCounter] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(1);
  const [codesChallengeFilter, setCodesChallengeFilter] = useState([]);

  const formatDate = (date) => {
    if (date) {
      var objectDate = new Date(date);
      var year = objectDate.getFullYear();
      var month = objectDate.getMonth() + 1;
      var day = objectDate.getDate();
      return `${year}/${month}/${day}`;
    }
  };

  const formatDateTableColuumn = (item) => {
    return {
      challengeAffiliateCodeId: item.challengeAffiliateCodeId,
      code: item.code,
      label: item.label,
      lastName: item.lastName,
      firstName: item.firstName,
      justification: item.justification,
      deliveredAt: formatDate(item.deliveredAt),
      updatedAt: formatDate(item.updatedAt),
      email: item.email,
      used: item.used,
      defaultValue: "- - - - - - - - -",
    };
  };

  const fetchPromoCodes = async ({ key, value, clear = false }) => {
    const newUrlSearchParams = new URLSearchParams(urlSearchParams);
    if (key && value !== "" && !clear) newUrlSearchParams.set(key, value);
    else newUrlSearchParams.delete(key);
    const filters = [...newUrlSearchParams.entries()].reduce((obj, [key, value]) => {
      obj[key] = obj[key]
        ? Array.isArray(obj[key])
          ? [...obj[key], value]
          : [obj[key], value]
        : value;
      return obj;
    }, {});
    const { success, data } = await getPromoCodes({ filters });
    if (success) {
      const codes = data.items.map((item) => formatDateTableColuumn(item));
      unstable_batchedUpdates(() => {
        setCodeRows(codes);
        setUrlSearchParams(newUrlSearchParams);
        if (data.hasPaging) {
          setItemsCounter(data.itemsCounter);
          setCurrentPage(data.hasPaging);
          setPageSize(data.paginSize);
          if (data.hasPaging !== currentPage) {
            newUrlSearchParams.set("page", data.hasPaging);
          }
        }
      });
    }
  };

  const fetchCounterChallengeCodes = async () => {
    const { success, data } = await getCounterChallengesCodes();
    if (success) {
      setCodesChallengeFilter(
        data.items.map((item) => ({ ...item, title: `Desafíos ${item.label}` }))
      );
    }
  };

  const updatePromeCode = async ({ newInfoPromeCode }) => {
    const { success, data } = await updateInfoPromCode({ newInfoPromeCode });
    if (success) {
      updateTable(data.item);
    }
  };

  const updateTable = (itemNewInfo) => {
    setCodeRows(
      codeRows.map((item) =>
        item.challengeAffiliateCodeId === itemNewInfo.challengeAffiliateCodeId
          ? formatDateTableColuumn({
              ...item,
              ...itemNewInfo,
            })
          : item
      )
    );
  };

  useEffect(() => {
    fetchPromoCodes({ key: "page", value: 1 });
    fetchCounterChallengeCodes();
  }, []);

  return (
    <DashboardLayout>
      <VuiTypography
        sx={{
          fontSize: "18px",
          fontWeight: "400",
          lineHeight: "27px",
          color: "#FFFFFF",
          padding: "0px 16px",
        }}
      >
        {labelPage}
      </VuiTypography>
      <Grid container>
        <AppCodesChallengeCounter
          codesChallengeFilter={codesChallengeFilter}
          fetchPromoCodes={fetchPromoCodes}
        />
        <AppCodesFilterState
          filterStateSelect={filterStateSelect}
          fetchPromoCodes={fetchPromoCodes}
        />
      </Grid>
      <AppCodesTable
        codesTableRows={codeRows}
        codesTableColumns={codesTableColumns}
        codesButtonStates={codesButtonStates}
        fetchPromoCodes={fetchPromoCodes}
        updatePromeCode={updatePromeCode}
      />
      <Paginated
        itemsCounter={itemsCounter}
        pageSize={pageSize}
        currentPage={currentPage}
        changePage={(page) => {
          fetchPromoCodes({
            key: "page",
            value: page,
          });
        }}
        changeSize={(size) => {
          fetchPromoCodes({
            key: "size",
            value: size
          })
        }}
      />
    </DashboardLayout>
  );
}
